import { checkboxAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { mode } from '@chakra-ui/theme-tools';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(checkboxAnatomy.keys);

const baseStyle = definePartsStyle(props => {
  const { colorScheme: c } = props; // extract colorScheme from component props

  const fillColor = mode(`${c}.300`, `${c}.500`)(props);

  return {
    control: {
      _checked: {
        bg: fillColor,
        borderColor: fillColor,
      },
      borderColor: "gray",
    },
    icon: {
      color: 'white',
    },
  };
});

export const checkboxTheme = defineMultiStyleConfig({ baseStyle });
